import {
  ColorGreen600,
  ColorNeutral300,
  ColorRed600,
  ColorYellow600,
} from '../../design-system/colors';
import { Spacing } from '../../design-system/spacing';
import { styled } from '../../utils/styled';
import { Box } from '../Box';
import { Stack } from '../Stack';
import { Typography } from '../Typography';

export const StyledBox = styled(Box)`
  gap: 2px;
  align-items: flex-start;
  border-radius: ${({ theme }) => theme.spacing(Spacing.Tiny)};
  background-color: ${({ theme }) => theme.palette.neutral[200]};
  width: 100%;
  overflow: hidden;
  margin-bottom: ${({ theme }) => theme.spacing(Spacing.Tiny)};
  display: flex;
`;

export const StyledValueStack = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing(Spacing.Tiny)};
  width: 100%;
`;

export const StyledItemsStack = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const colorList = [ColorGreen600, ColorYellow600, ColorRed600, ColorNeutral300];

export const FilledBar = styled(Box)<{
  index: number;
  value: number;
}>`
  align-items: flex-start;
  background-color: ${({ index, value }) =>
    value === 0 ? colorList[4] : colorList[index]};
  width: ${({ value }) => (value === 0 ? 'unset' : value)}%;
  height: 4px;
`;

export const StyledTypography = styled(Typography)`
  flex: 1;
  text-align: center;
  &:first-of-type {
    text-align: start;
  }
  &:last-of-type {
    text-align: end;
  }
  align-items: baseline;
`;
export const StyledTypographyCentered = styled(Typography)`
  flex: 1;
  text-align: center;
  &:first-of-type {
    text-align: start;
  }
  &:last-of-type {
    text-align: end;
  }
  align-items: center;
`;
